import { API } from "aws-amplify";
import { updateMoveExam } from "~/graphql/mutations";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";
import { EMPTY_MOVE_EXAM_INFO } from "../getLeaseInfo/getMoveExamInfo";

export const editMoveExam = async (
  payload: APITypes.UpdateMoveExamInput
): Promise<LoaderData<APITypes.MoveExam>> => {
  try {
    const response = (await API.graphql({
      query: updateMoveExam,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.UpdateMoveExamMutation };

    return {
      success: true,
      data: response.data?.updateMoveExam || EMPTY_MOVE_EXAM_INFO,
    };
  } catch (error) {
    console.error("Error editing move exam", error);
    return {
      success: false,
      data: EMPTY_MOVE_EXAM_INFO,
      error,
    };
  }
};
